export const getters = {
  getModalViewInvestment: state => state.modalViewInvestment,
  getInvestments: state => state.investments,
  getInvestment: state => state.investment,
  getPayInvestment: state => state.payInvestment,
  getListPayInvestments: state => state.listPayInvestments
};

export default {};
